import {Link} from 'react-router-dom';
import {ReactNode} from 'react';
import {AuthLayoutFooter} from './auth-layout-footer';
import {useIsDarkMode} from '@common/ui/themes/use-is-dark-mode';
import {useTrans} from '@common/i18n/use-trans';
import {useSettings} from '@common/core/settings/use-settings';
import './auth-layout.css';

interface AuthPageProps {
  heading?: ReactNode;
  message?: ReactNode;
  children: ReactNode;
}

export function AuthLayout({heading, children, message}: AuthPageProps) {
  const {branding} = useSettings();
  const isDarkMode = useIsDarkMode();
  const {trans} = useTrans();

  return (
    <div className="rp-auth">
      {/* ── Left panel ── */}
      <div className="rp-auth__left">
        {/* Logo */}
        <Link
          to="/"
          className="rp-auth__logo"
          aria-label={trans({message: 'Go to homepage'})}
        >
          <img
            src={isDarkMode ? branding.logo_light : branding?.logo_dark}
            className="rp-auth__logo-img"
            alt={branding.site_name}
          />
        </Link>

        {/* Centered form area */}
        <div className="rp-auth__form-wrap">
          {heading && <h1 className="rp-auth__heading">{heading}</h1>}
          <div className="rp-auth__form-body">
            {children}
          </div>
          {message && <div className="rp-auth__message">{message}</div>}
        </div>

        {/* Footer */}
        <div className="rp-auth__footer-wrap">
          <AuthLayoutFooter />
        </div>
      </div>

      {/* ── Right panel ── */}
      <div className="rp-auth__right" aria-hidden="true">
        <div className="rp-auth__right-inner">
          <div className="rp-auth__tagline">
            <span className="rp-auth__tagline-eyebrow">platform</span>
            <span className="rp-auth__tagline-text">Build and ship<br/>faster than ever</span>
            <span className="rp-auth__tagline-badge">
              <span className="rp-auth__tagline-dot" />
              {branding.site_name}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

